import {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
} from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const [imagesCollection, setImagesCollection] = useState();
  const [imagesSelectedId, setImageSelectedId] = useState();

  const openModal = useCallback(({ images, imageSelectedId }) => {
    setModalOpen(true);
    setImagesCollection(images);
    setImageSelectedId(imageSelectedId);
  }, []);

  const value = useMemo(
    () => ({
      imagesCollection,
      imagesSelectedId,
      isModalOpen,
      openModal,
      setModalOpen,
      setImagesCollection,
      setImageSelectedId,
    }),
    [
      imagesCollection,
      imagesSelectedId,
      isModalOpen,
      openModal,
      setModalOpen,
      setImagesCollection,
      setImageSelectedId,
    ],
  );

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};

export const useModalContext = () => useContext(ModalContext);

export default ModalContext;
